import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { ConfigService } from './config.service';
import { NotificationSubscription } from '../model/notification-subscription';
import {Observable, throwError} from "rxjs";
import { BasicResponse } from '../model/basic-response';
import {catchError} from "rxjs/operators";
import {NotifyMessage, SortFilterInterface} from "../..";
import {PushNotificationLog} from "../model/push-notification-log";

export interface subScriptionAPI {
  items: NotificationSubscription[];
  total_count: number;
}

export interface pushNotificationLogAPI {
  items: PushNotificationLog[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private URL;
  headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url + '/notify';
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  private static handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }


  getUserPushSubscriptions(uacid: number): Observable<subScriptionAPI> {
    const headers = this.headers;

    return this.httpClient.get<subScriptionAPI>(`${this.URL}/user/${uacid}`, {headers})
        .pipe(
            catchError(NotificationService.handleError)
        );
  }

  deleteSubscription(sub: NotificationSubscription) {
    const headers = this.headers;
    return this.httpClient.delete<BasicResponse>(`${this.URL}/user/sub/${sub.id}`, {headers})
        .pipe(
            catchError(NotificationService.handleError)
        );

  }

  sendNotification(notification: NotifyMessage): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/msg/send`, notification, {headers})
        .pipe(
            catchError(NotificationService.handleError)
        );

  }

  getPushNotificationLog(subID: number, pageIndex: number,
                         pageSize: number,
                         sortActive: string,
                         sort: string, sortFilter: SortFilterInterface): Observable<pushNotificationLogAPI> {
    const headers = this.headers;

    if ((sortActive === '') || (sort === '')) {
      sortActive = '0';
      sort = 'asc';
    }

    return this.httpClient.post<pushNotificationLogAPI>(`${this.URL}/msg/log/${subID}/${pageIndex}/${pageSize}/${sortActive}/${sort}`, sortFilter, {headers})
        .pipe(
            catchError(NotificationService.handleError)
        );
  }
}


